import { FlexGrid, FlexGridItem } from 'baseui/flex-grid'
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ROLE } from 'baseui/modal'
import { Checkbox } from 'baseui/checkbox'
import SDPaginator from '@/shared/components/SDComponents/SDPaginator/SDPaginator'
import useAdditionalProductsTools from '../DevTools/useAdditionalProductsTools'
import AdditionalProductsList from './AdditionalProductsList'
import SDSelect from '@/shared/components/SDComponents/SDSelect/SDSelect'
import { FormControl } from 'baseui/form-control'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import ModalResources from './ModalResources/ModalResources'

const AdditionalProductsTools = () => {
  const {
    search,
    setSearch,
    page,
    setPage,
    sortKey,
    sortDirection,
    handleSort,
    showOnlyDeleted,
    showOnlyActive,
    toggleShowOnlyDeleted,
    toggleShowOnlyActive,
    confirmAction,
    closeModal,
    confirmActionAndExecute,
    openDeleteModal,
    openRestoreModal,
    actionLoadingId,
    isLoading,
    error,
    debouncedSearch,
    paginated,
    filteredTotal,
    numPages,
    distinctProductTypes,
    selectedProductType,
    setProductType,
    isOpen,
    close,
    setIsOpen,
    resources,
    tinymceKey,
    updateResources,
    saveResources,
    isSavingResources,
  } = useAdditionalProductsTools()

  return (
    <>
      <FlexGrid flexGridColumnCount={2} marginBottom='.5rem'>
        <FlexGridItem>
          <FormControl label='Choose product type'>
            <SDSelect
              options={distinctProductTypes}
              value={selectedProductType || []}
              onChange={params => setProductType(params?.value || null)}
            />
          </FormControl>
        </FlexGridItem>
        {selectedProductType?.length > 0 && (
          <FlexGridItem display='flex' alignItems='center' justifyContent='flex-end'>
            <SDButton onClick={() => setIsOpen(true)}>Edit Resources</SDButton>
            <ModalResources
              isOpen={isOpen}
              close={close}
              selectedProductType={selectedProductType}
              resources={resources[selectedProductType[0]?.value] || []}
              tinymceKey={tinymceKey}
              updateResources={updateResources}
              saveResources={saveResources}
              isSavingResources={isSavingResources}
            />
          </FlexGridItem>
        )}
      </FlexGrid>
      {selectedProductType?.length > 0 && (
        <>
          <FlexGrid flexGridColumnCount={2} marginBottom='.5rem' flexGridColumnGap='scale800'>
            <FlexGridItem display='flex' alignItems='center'>
              <input
                type='text'
                placeholder='Filter by name / zoho_id'
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={{ height: 36, padding: '0 8px', borderRadius: 6, border: '1px solid #ccc', minWidth: 320 }}
              />
              {search && debouncedSearch !== search && (
                <span style={{ marginLeft: 8, fontSize: 12, opacity: 0.7 }}>filtering...</span>
              )}
              {search !== '' && (
                <button
                  style={{
                    marginLeft: 8,
                    border: 'none',
                    background: '#eee',
                    padding: '4px 8px',
                    borderRadius: 4,
                    cursor: 'pointer',
                  }}
                  onClick={() => setSearch('')}
                >
                  Clear
                </button>
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginLeft: 24 }}>
                <Checkbox checked={showOnlyDeleted} onChange={toggleShowOnlyDeleted}>
                  Only deleted
                </Checkbox>
                <Checkbox checked={showOnlyActive} onChange={toggleShowOnlyActive}>
                  Only active
                </Checkbox>
              </div>
            </FlexGridItem>
            <FlexGridItem display='flex' alignItems='center' justifyContent='flex-end'>
              {isLoading && <span>Loading…</span>}
              {error && <span style={{ color: 'red' }}>{error}</span>}
            </FlexGridItem>
          </FlexGrid>
          <AdditionalProductsList
            items={paginated}
            onSort={handleSort}
            sortKey={sortKey}
            sortDirection={sortDirection}
            onDelete={openDeleteModal}
            onRestore={openRestoreModal}
            loadingId={actionLoadingId}
          />
          <SDPaginator
            numPages={numPages}
            currentPage={page}
            onPageChange={({ nextPage }) => setPage(Math.min(Math.max(nextPage, 1), numPages))}
          />
          <div style={{ marginTop: 8, fontSize: 12 }}>
            Total: {filteredTotal} | Page {page}/{numPages} | Filter: {debouncedSearch || '---'}
          </div>
          <Modal
            onClose={closeModal}
            closeable
            isOpen={Boolean(confirmAction)}
            animate
            role={ROLE.dialog}
            size='default'
            unstable_ModalBackdropScroll
          >
            <ModalHeader>Confirmation</ModalHeader>
            <ModalBody>
              {confirmAction && (
                <p>
                  Are you sure you want to {confirmAction.type === 'delete' ? 'delete' : 'restore'}{' '}
                  <strong>{confirmAction.product.name}</strong> (#{confirmAction.product.id})?
                </p>
              )}
            </ModalBody>
            <ModalFooter>
              <ModalButton kind='tertiary' onClick={closeModal}>
                Cancel
              </ModalButton>
              <ModalButton
                onClick={confirmActionAndExecute}
                isLoading={confirmAction && actionLoadingId === confirmAction.product.id}
                kind={confirmAction?.type === 'delete' ? 'secondary' : 'primary'}
              >
                {confirmAction?.type === 'delete' ? 'Delete' : 'Restore'}
              </ModalButton>
            </ModalFooter>
          </Modal>
        </>
      )}
    </>
  )
}

export default AdditionalProductsTools
